import { motion } from "framer-motion";
import { useSite, waLink } from "@/lib/site";

export const WaIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden><path d="M17.47 14.38c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.67-1.61-.92-2.21-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48s1.07 2.88 1.21 3.08c.15.2 2.1 3.2 5.08 4.49.71.31 1.26.49 1.69.63.71.23 1.36.19 1.87.12.57-.09 1.76-.72 2.01-1.41.25-.7.25-1.29.17-1.41-.07-.13-.27-.2-.57-.35M12.05 21.5h-.01a9.4 9.4 0 0 1-4.8-1.31l-.34-.2-3.57.94.95-3.48-.22-.36a9.4 9.4 0 0 1-1.44-5.02c0-5.2 4.23-9.43 9.44-9.43a9.38 9.38 0 0 1 9.43 9.44c0 5.2-4.23 9.43-9.44 9.43m8.03-17.46A11.27 11.27 0 0 0 12.05.72C5.8.72.7 5.8.7 12.07c0 2 .52 3.95 1.52 5.67L.6 23.65l6.05-1.59a11.3 11.3 0 0 0 5.4 1.38h.01c6.26 0 11.35-5.09 11.35-11.36 0-3.03-1.18-5.88-3.33-8.03" /></svg>
);

export const WaButton = ({ text, label, className = "btn-gold", testid }) => {
  const { settings } = useSite();
  const href = waLink(settings?.whatsapp, text);
  if (!href) return null;
  return <a href={href} target="_blank" rel="noreferrer" className={`${className} gap-2`} data-testid={testid}><WaIcon size={15} />{label}</a>;
};

export const WaFloat = () => {
  const { settings } = useSite();
  const href = waLink(settings?.whatsapp, "");
  if (!href) return null;
  return (
    <motion.a href={href} target="_blank" rel="noreferrer" data-testid="whatsapp-float" aria-label="WhatsApp"
      initial={{ scale: 0, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} transition={{ delay: 3.4, type: "spring" }} whileHover={{ scale: 1.08 }}
      className="fixed bottom-5 end-5 z-[55] w-14 h-14 rounded-full bg-midnight border border-gold/60 text-gold flex items-center justify-center shadow-[0_10px_40px_-10px_rgba(16,42,58,0.7)]">
      <span className="absolute inset-0 rounded-full border border-gold/40 animate-ping" />
      <WaIcon size={24} />
    </motion.a>
  );
};
